import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getPinInfo } from '@/help.search';
let Result = class Result extends Vue {
    get pinClass() {
        return getPinInfo(this.data).pinClass; //TODO:MAP
    }
    get pinTitle() {
        return getPinInfo(this.data).pinTitle;
    }
    toggle() {
        this.$emit('result-toggle', this.data.id);
    }
};
tslib_1.__decorate([
    Prop()
], Result.prototype, "data", void 0);
Result = tslib_1.__decorate([
    Component
], Result);
export default Result;
